import { useMemo } from 'react';

import { ServiceType } from '@/shared/api/protocol-ts/api/billing_new/dto_services_new_pb';
import { StudyType } from '@/shared/api/protocol-ts/model/dto_study_pb';
import { useAppSelector } from '@/shared/hooks';

import { STUDY_TO_SERVICES_MAP, StudyToServiceMap } from '@/entities/billing';

import * as composedModel from '../model';

export const useDiagnocoinFunding = (serviceTypes: readonly ServiceType[]) => {
  const selectFunding = useMemo(
    () => composedModel.selectors.makeSelectDiagnocoinFunding(serviceTypes),
    [serviceTypes],
  );

  return useAppSelector(selectFunding);
};

export const useDiagnocoinFundingByStudyType = (
  studyType: StudyType | undefined,
) => {
  const serviceTypes = useMemo(() => {
    const serviceType =
      STUDY_TO_SERVICES_MAP[studyType as keyof StudyToServiceMap];

    return serviceType === undefined ? [] : [serviceType];
  }, [studyType]);

  return useDiagnocoinFunding(serviceTypes);
};
